import React from 'react';
import { Link } from 'react-router-dom';
import './ProfileDropdown.css';

function ProfileDropdown({ user, rider, onLogout, onClose }) {
  if (!user) return null;

  return (
    <div className="profile-dropdown-overlay" onClick={onClose}>
      <div className="profile-dropdown" onClick={(e) => e.stopPropagation()}>
        <div className="profile-dropdown-header">
          <h3>{rider?.first_name && rider?.last_name ? `${rider.first_name} ${rider.last_name}` : (user.displayName || 'Rider')}</h3>
          <p>{user.email}{rider?.phoneNumber && ` · ${rider.phoneNumber}`}</p>
        </div>
        <div className="profile-dropdown-body">
          <Link to="/settings" className="profile-dropdown-item" onClick={onClose}>
            <span>My Profile</span>
          </Link>
          <Link to="/orders" className="profile-dropdown-item" onClick={onClose}>
            <span>My Orders</span>
          </Link>
          <Link to="/favorites" className="profile-dropdown-item" onClick={onClose}>
            <span>Favorites</span>
          </Link>
        </div>
        <div className="profile-dropdown-footer">
          <button onClick={onLogout} className="profile-dropdown-item logout-btn">
            <span>Log Out</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProfileDropdown;